import dayjs from "dayjs";

import { DeviceLink } from "@/shared/components/DeviceLink";
import { TagList } from "@/shared/components/TagList";
import { UserLink } from "@/shared/components/UserLink";
import {
  cellStyles,
  createColumnHelper,
  type ICellRendererParams,
} from "@/shared/foundation/primitives/Table";
import { RobotoPrincipal, RobotoPrincipalType } from "@/shared/principal";

import { type Device } from "./Device";

const columnHelper = createColumnHelper<Device>();

function formatRelativeDate(value: string | undefined | null): string {
  if (!value) {
    return "";
  }
  const date = dayjs(value);
  return dayjs().diff(date, "day") >= 7
    ? date.format("MMM D, YYYY")
    : date.fromNow();
}

function renderPrincipal(value: string | null | undefined) {
  const raw = value ?? "";
  const principal = RobotoPrincipal.fromString(raw);
  if (principal?.ptype === RobotoPrincipalType.User) {
    return (
      <UserLink
        userId={principal.unqualifiedId}
        linkSx={{ fontSize: "var(--font-size-xs)" }}
      />
    );
  }
  return <span>{principal?.unqualifiedId ?? raw}</span>;
}

export const devicesTableColumns = [
  columnHelper.accessor("device_id", {
    headerName: "Device ID",
    width: 220,
    hide: false,
    sortable: true,
    cellClass: cellStyles.monoCell,
    cellRenderer: (p: ICellRendererParams<Device, string>) =>
      p.value ? <DeviceLink deviceId={p.value} /> : null,
  }),
  columnHelper.accessor("tags", {
    headerName: "Tags",
    flex: 2,
    hide: false,
    cellClass: cellStyles.tagsCell,
    valueFormatter: (p) => (p.value ?? []).join(", "),
    cellRenderer: (p: ICellRendererParams<Device, string[]>) => (
      <TagList tags={p.value ?? []} maxDisplayCount={3} />
    ),
  }),
  columnHelper.accessor("created_by", {
    headerName: "Created By",
    width: 150,
    hide: false,
    sortable: true,
    cellRenderer: (p: ICellRendererParams<Device, string>) =>
      renderPrincipal(p.value),
  }),
  columnHelper.accessor("created", {
    headerName: "Created",
    width: 150,
    hide: false,
    sortable: true,
    valueFormatter: (p) => formatRelativeDate(p.value),
  }),
  columnHelper.accessor("modified", {
    headerName: "Modified",
    width: 150,
    sortable: true,
    valueFormatter: (p) => formatRelativeDate(p.value),
  }),
  columnHelper.accessor("modified_by", {
    headerName: "Modified By",
    width: 150,
    sortable: true,
    cellRenderer: (p: ICellRendererParams<Device, string>) =>
      renderPrincipal(p.value),
  }),
];
